<template>
    <div class="buyerOrderDetail11">
        <div class="searchBox">
            <div class="left">
                <div>
                  <span>{{userName}} 成交总金额：{{totalAmount}}元</span>
                  <span> ; </span>
                  <span>{{userName}} 成交总笔数：{{totalOrderNum}}笔</span>
                </div>
            </div>
            <div class="right">
                <el-form :inline="true">
                  <el-form-item>
                      <el-select placeholder="公司" v-model="formObj.userType" @change="multiSearchClick">
                          <el-option label="公司" value=""></el-option>
                          <el-option :label="list.text" :value="list.value" v-for="(list,index) in userTypeOptions" :key="index"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item>
                      <el-select placeholder="品牌" v-model="formObj.userType" @change="multiSearchClick">
                          <el-option label="品牌" value=""></el-option>
                          <el-option :label="list.text" :value="list.value" v-for="(list,index) in userTypeOptions" :key="index"></el-option>
                      </el-select>
                  </el-form-item>
                    <el-form-item>
                       <el-button type="primary">下载列表</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <el-table-column type="selection" width="35">
                </el-table-column>
                <el-table-column label="序号" width="40">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="订单号">
                    <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
                </el-table-column>
                <el-table-column label="用户姓名" width="50">
                    <template slot-scope="scope">{{ scope.row.realName }}</template>
                </el-table-column>
                <el-table-column label="总数" width="50">
                    <template slot-scope="scope">{{ scope.row.quantity }} 件</template>
                </el-table-column>
                <el-table-column label="总金额">
                    <template slot-scope="scope">{{ scope.row.amount }} 元</template>
                </el-table-column>
                <el-table-column label="下单时间">
                    <template slot-scope="scope">{{ scope.row.submitTime }}</template>
                </el-table-column>
                <el-table-column label="状态" width="50">
                    <template slot-scope="scope">
                    <span :class="{red:scope.row.orderState=='1',green:scope.row.orderState=='2',orange_lighter:scope.row.orderState=='3'}">{{ scope.row.orderState |turnValToText('order_pay_status')}}</span>

                    </template>

                </el-table-column>
                <el-table-column label="公司">
                    <template slot-scope="scope">{{ scope.row.ces }}</template>
                </el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <div class="oneItem picture" v-for="(list,index) in scope.row.list" :key="list.imageFile">
                            <img :src="IMG_PREV+list.imageFile" alt="">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="品牌" width="50">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.ces}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="款号">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.styleNumber}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="商品名称">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.itemName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="颜色" width="50">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.colorName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="数量" width="50">
                    <template slot-scope="scope">
                        <div class="oneItem" v-for="(list,index) in scope.row.list">{{list.totalNum}} 件</div>
                    </template>
                </el-table-column>
                
                <el-table-column label="操作"  width="130">
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <span class="spanBtn" @click="toDetail(scope.row)">查看</span>
                             <span class="spanBtn orange" @click="checkReceiveMoney(scope.row)" v-if="scope.row.orderState==1&&functionConfirmReceivedMoney">确认收款</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                userName:'',
                conferenceId:'',
                userId:'',
                totalAmount:'',
                totalOrderNum:'',
                isLoading:false,
                tableData:[],
                formObj:{
                    fuzzyQuery:'',
                    userType:'',
                    authResult:'',
                    systemResult:'',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                total:0,
            }
        },
        components: {
        },
        computed: {
            functionConfirmReceivedMoney(){
                return utils.getCurrentFunction().indexOf("confirmReceivedMoney")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            
        },
        methods: {
            refreshPage(){
              this.getTableLists()  
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                this.userId = this.$route.params.userId
                this.userName = this.$route.params.userName
            },
            checkReceiveMoney(list) {
                let _this = this
                if(!confirm("确认该订单已收款吗？")){
                    return false
                }
                let arg = {
                    orderNumber: list.orderNumber
                }
                ajaxPost('/admin/confirmPay', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "确认收款成功",
                            type: 'success',
                            duration: 1500
                        });
                        _this.refreshPage()
                    }
                }, function(res) {
            
                })
            },
            fuzzySearchClick() {
                this.searchObj = {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            multiSearchClick() {
                this.searchObj = {
                    authResult: this.formObj.authResult,
                    userType: this.formObj.userType,
                    systemResult:this.formObj.systemResult,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            getTableLists(){
                let _this=this
                let arg=JSON.parse(JSON.stringify( _this.searchObj))
                arg.conferenceId=_this.conferenceId
                arg.userId=_this.userId
                ajaxPost('/admin/getbuyerOrder',arg).then(function(res) {
                    // _this.tableData=res.data.re viewList?res.data.reviewList:[]
                    _this.tableData=res.data
                    _this.total=parseInt(res.data.total) 
                    _this.customerTotal=res.data.total
                    

                }, function(res) {
                
                })
            },
            toDetail(list) {
                let _this=this 
                let orderNumber=list.orderNumber
                this.$router.push({name: 'activeInnerOrderDetail',params: { conferenceId: _this.conferenceId ,orderNumber:orderNumber}})
            },
        },
        mounted(){
           this.getParams()
           this.getTableLists()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    // *{outline: 1px solid blue;}
    .buyerOrderDetail11 {
        .oneItem{border-bottom:1px solid #efefef;height: 50px;padding:3px;}
        .oneItem:last-child{border-bottom:0}
      background: #fff;
       .el-table .cell{font-size: 12px;padding:4px 0;}
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
             float:right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       
       .tableBox {
           padding: 0.25rem; padding-top:0;
           // .oneItem{border-bottom:1px solid blue;}
           .oneItem.picture{ 
               height: 50px;
               img{max-width: 100%;max-height: 100%;}
           }
           
       }
       
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/buyerOrderDetail.vue